import { Breakpoints } from '@estee/elc-base-theme';
import { OrderStatusType } from '../domain/entities/Config';

const KEY_PRESS_ENTER = 'Enter';

// Drupal translation key.
const REG_TRANSLATION_PLACEHOLDER = '^::[a-z_]+.[a-z_]+::$';

const REG_SIGN_IN_PLACEHOLDER = '::SIGN_IN::';

const REG_SPACE = /\s/g;

const REG_TRACKING_NUMBER = /::tracking_number::/g;

const REG_PLACEHOLDER = /::\s*([a-z0-9_]+)\s*::/g;

const DEFAULT_DATE_FORMAT = 'dd/MM/yyyy';

const SCROLL_BLOCK = 'start';

const SCROLL_BEHAVIOR = 'smooth';

const SCROLL_QUERY = `(min-width: ${Breakpoints.desktop}px)`;

const INVALID_DATE = 'Invalid Date';

const DEFAULT_DATETIME_FORMAT = 'LLL d';

const DEFAULT_DATETIME_STAMP_FORMAT = 'LLL d p';

const SAMPLE_ITEM = 'Samples';

export {
    KEY_PRESS_ENTER,
    REG_TRANSLATION_PLACEHOLDER,
    REG_SIGN_IN_PLACEHOLDER,
    REG_SPACE,
    REG_PLACEHOLDER,
    DEFAULT_DATE_FORMAT,
    REG_TRACKING_NUMBER,
    SCROLL_BLOCK,
    SCROLL_BEHAVIOR,
    SCROLL_QUERY,
    INVALID_DATE,
    DEFAULT_DATETIME_FORMAT,
    DEFAULT_DATETIME_STAMP_FORMAT,
    SAMPLE_ITEM
};

export enum ErrorMessageType {
    ORDER_NOT_FOUND,
    ORDER_NUMBER_INVALID,
    GENERIC,
    TRACK_MY_ORDER_IS_NOT_AVAILABLE
}

export enum OrderTrackingSearchParam {
    // Search params from tracking link in order confirmation email
    DATA = 'DATA',
    TOKEN = 'TOKEN',

    // Search params used in API endpoint
    REGION = 'region',
    BRAND = 'brand'
}

// To avoid getting the wrong brand/region value due to DeepSearchResolver behavior in configuration manager
export const brandIdValPath = 'brand.id';
export const regionIdValPath = 'region.id';

// This mapping is used for filtering which status label appear on the progress bar when order is (orderProcessing, atWarehouse, shipped, delivered, returnInProgress, delayed)
export const PROGRESS_MILESTONES_BY_STATUS = {
    [OrderStatusType.ORDER_PROCESSING]: [
        OrderStatusType.ORDER_PROCESSING,
        OrderStatusType.SHIPPED,
        OrderStatusType.DELIVERED
    ],
    [OrderStatusType.AT_WAREHOUSE]: [
        OrderStatusType.AT_WAREHOUSE,
        OrderStatusType.SHIPPED,
        OrderStatusType.DELIVERED
    ],
    [OrderStatusType.SHIPPED]: [
        OrderStatusType.ORDER_PROCESSING,
        OrderStatusType.SHIPPED,
        OrderStatusType.DELIVERED
    ],
    [OrderStatusType.CANCELLED]: [OrderStatusType.CANCELLED],
    [OrderStatusType.DELAYED]: [
        OrderStatusType.ORDER_PROCESSING,
        OrderStatusType.DELAYED,
        OrderStatusType.DELIVERED
    ],
    [OrderStatusType.DELIVERED]: [
        OrderStatusType.ORDER_PROCESSING,
        OrderStatusType.SHIPPED,
        OrderStatusType.DELIVERED
    ],
    [OrderStatusType.UNDELIVERABLE]: [OrderStatusType.UNDELIVERABLE]
};

export const DEFAULT_ITEM_TO_SLICE = 2;

export const DEFAULT_ORDER_PATH = '/rest/api/v1/transaction/tracking';
